export default __webpack_public_path__ + "static/media/icon-coin-rpl.1797872c.svg";